import { makeStyles } from '@material-ui/styles'
import Card from 'core/elements/card'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Ellipsis from 'core/components/progress/loader-svgs/Ellipsis'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import StatusCountItem, { StatusVariant } from './StatusCountItem'

export interface StatusCount {
  tooltip: string
  count: number
  variant: StatusVariant
  icon?: string
}

interface ResourceStatusCardProps {
  title: string
  linkText: string
  linkIcon?: string
  onLinkClick: () => void
  loading?: boolean
  statusCounts: StatusCount[]
}

const ResourceStatusCard = ({
  title,
  linkText,
  linkIcon = 'chevron-right',
  onLinkClick,
  loading = false,
  statusCounts,
}: ResourceStatusCardProps) => {
  const classes = useStyles()

  return (
    <Card className={classes.statusCard}>
      <div className={classes.cardBody}>
        <div className={classes.statusHeader}>
          <Text variant="subtitle2">{title}</Text>
          <Text variant="caption2" className={classes.seeAll} onClick={onLinkClick}>
            {linkText}{' '}
            <FontAwesomeIcon regular className={classes.arrow}>
              {linkIcon}
            </FontAwesomeIcon>
          </Text>
        </div>
        {loading ? (
          <Ellipsis />
        ) : (
          <div className={classes.icons}>
            {statusCounts.map((status, index) => (
              <div key={status.tooltip} className={classes.statusItem}>
                <StatusCountItem
                  tooltip={status.tooltip}
                  count={status.count}
                  variant={status.variant}
                  icon={status.icon}
                />
                {index < statusCounts.length - 1 && <div className={classes.divider} />}
              </div>
            ))}
          </div>
        )}
      </div>
    </Card>
  )
}

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  statusCard: {
    flexGrow: 1,
    width: '100%',
  },
  cardBody: {
    display: 'grid',
    gap: 12,
  },
  statusHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  seeAll: {
    cursor: 'pointer',
  },
  arrow: {
    fontSize: 12,
  },
  icons: {
    display: 'flex',
    gap: 16,
  },
  statusItem: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  divider: {
    width: 1,
    height: 32,
    background: theme.components.card.text,
  },
}))

export default ResourceStatusCard
